// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-card {
  background: var(--card-bg);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.services-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #8B4513, #D2691E, #8B4513);
  border-radius: 20px 20px 0 0;
}

.services-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.services-header {
  text-align: center;
  margin-bottom: 2rem;
}

.services-title-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.services-emoji {
  font-size: 2rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.services-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  background: linear-gradient(135deg, #8B4513, #D2691E);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.services-subtitle {
  color: var(--text-secondary);
  font-size: 1rem;
  margin: 0;
  opacity: 0.8;
}

.services-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.service-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-light);
  transition: all 0.3s ease;
}

.service-item:hover {
  background: var(--hover-bg);
  transform: translateX(5px);
  border-color: var(--accent-color);
}

.service-icon {
  font-size: 1.5rem;
  min-width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-bg);
  border-radius: 8px;
  flex-shrink: 0;
}

.service-content {
  flex: 1;
}

.service-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
}

.service-description {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}

.services-actions {
  text-align: center;
}

.view-details-btn {
  background: linear-gradient(135deg, #8B4513, #D2691E);
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(139, 69, 19, 0.3);
}

.view-details-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);
  background: linear-gradient(135deg, #A0522D, #CD853F);
}

.view-details-btn:active {
  transform: translateY(0);
}

/* Dark theme support */
[data-theme="dark"] .services-card {
  background: var(--card-bg);
  border-color: var(--border-color);
}

[data-theme="dark"] .service-item {
  background: var(--bg-secondary);
  border-color: var(--border-light);
}

[data-theme="dark"] .service-item:hover {
  background: var(--hover-bg);
  border-color: var(--accent-color);
}

/* Responsive Design */
@media (max-width: 768px) {
  .services-card {
    padding: 1.5rem;
  }
  
  .services-title {
    font-size: 1.5rem;
  }
  
  .service-item {
    padding: 0.8rem;
  }
  
  .service-title {
    font-size: 1rem;
  }
  
  .service-description {
    font-size: 0.85rem;
  }
  
  .view-details-btn {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .services-card {
    padding: 1rem;
  }
  
  .services-title-section {
    flex-direction: column;
    gap: 0.3rem;
  }
  
  .services-emoji {
    font-size: 1.5rem;
  }
  
  .services-title {
    font-size: 1.3rem;
  }
  
  .service-item {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
  
  .service-icon {
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServicesCard/ServicesCard.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".services-card {\n  background: var(--card-bg);\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.services-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #8B4513, #D2691E, #8B4513);\n  border-radius: 20px 20px 0 0;\n}\n\n.services-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.services-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.services-title-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.services-emoji {\n  font-size: 2rem;\n  animation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n.services-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  background: linear-gradient(135deg, #8B4513, #D2691E);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.services-subtitle {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  margin: 0;\n  opacity: 0.8;\n}\n\n.services-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.service-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  border: 1px solid var(--border-light);\n  transition: all 0.3s ease;\n}\n\n.service-item:hover {\n  background: var(--hover-bg);\n  transform: translateX(5px);\n  border-color: var(--accent-color);\n}\n\n.service-icon {\n  font-size: 1.5rem;\n  min-width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent-bg);\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.service-content {\n  flex: 1;\n}\n\n.service-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem 0;\n}\n\n.service-description {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.services-actions {\n  text-align: center;\n}\n\n.view-details-btn {\n  background: linear-gradient(135deg, #8B4513, #D2691E);\n  color: white;\n  border: none;\n  padding: 0.8rem 2rem;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(139, 69, 19, 0.3);\n}\n\n.view-details-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);\n  background: linear-gradient(135deg, #A0522D, #CD853F);\n}\n\n.view-details-btn:active {\n  transform: translateY(0);\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .services-card {\n  background: var(--card-bg);\n  border-color: var(--border-color);\n}\n\n[data-theme=\"dark\"] .service-item {\n  background: var(--bg-secondary);\n  border-color: var(--border-light);\n}\n\n[data-theme=\"dark\"] .service-item:hover {\n  background: var(--hover-bg);\n  border-color: var(--accent-color);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .services-card {\n    padding: 1.5rem;\n  }\n  \n  .services-title {\n    font-size: 1.5rem;\n  }\n  \n  .service-item {\n    padding: 0.8rem;\n  }\n  \n  .service-title {\n    font-size: 1rem;\n  }\n  \n  .service-description {\n    font-size: 0.85rem;\n  }\n  \n  .view-details-btn {\n    padding: 0.7rem 1.5rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .services-card {\n    padding: 1rem;\n  }\n  \n  .services-title-section {\n    flex-direction: column;\n    gap: 0.3rem;\n  }\n  \n  .services-emoji {\n    font-size: 1.5rem;\n  }\n  \n  .services-title {\n    font-size: 1.3rem;\n  }\n  \n  .service-item {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.5rem;\n  }\n  \n  .service-icon {\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
